function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "icon_hensyuu",
  d: "M786.667-1723.642a.667.667,0,0,1-.667-.667v-2.381a.668.668,0,0,1,.2-.472l9.155-9.154A2.319,2.319,0,0,1,797-1737a2.318,2.318,0,0,1,1.65.684,2.314,2.314,0,0,1,.683,1.65,2.314,2.314,0,0,1-.683,1.65l-.981.981-.019.02-.019.018-8.16,8.16a.664.664,0,0,1-.471.2Zm.667-2.772v1.438h1.391l7.512-7.511-1.414-1.415Zm9.845-7.016.528-.528a.994.994,0,0,0,.293-.707.994.994,0,0,0-.293-.707.991.991,0,0,0-.706-.292.993.993,0,0,0-.707.292l-.529.529Z",
  transform: "translate(-786 1737)",
  fill: "#545454"
});

var SvgIconHensyuu = function SvgIconHensyuu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.333,
    height: 13.358,
    viewBox: "0 0 13.333 13.358",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconHensyuu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_hensyuu.b3382301.svg";
export { ForwardRef as ReactComponent };